/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multisensors_Associated_With_GatewayInputs */



/**
* | output |
* | --- |
* | "Multisensors are associated with this gateway" |
*
* @param {Multisensors_Associated_With_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const multisensors_associated_with_gateway = /** @type {((inputs?: Multisensors_Associated_With_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multisensors_Associated_With_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Multisensors are associated with this gateway")
	return /** @type {LocalizedString} */ ("Des multicapteurs sont associés à cette box")
});